import React, { Fragment } from 'react';
import SideNav from 'pages/studyOverview/components/SideNav';
import {
    TwoColumnScaffold,
    LeftColumn,
    RightColumn
} from 'pages/studyOverview/components/TwoColumnScaffold';
import styles from './BindersV4.scss';
import lodash from 'lodash';

const buildBuilderTypeLinks = () => {
    const links = [
        {
            to: '/binders/study',
            title: 'Study Binders',
        },
        {
            to: '/binders/administrative',
            title: 'Administrative Binders',
        },
    ];
    return links.filter(link => link);
};

export default function BindersV4(props) {

    const sideNavLinks = buildBuilderTypeLinks();
    return (
        <Fragment>
            <TwoColumnScaffold className={styles.dashboardContainer}>
                <LeftColumn>
                    <SideNav
                        location={props.location}
                        activeIndex={() =>
                            lodash.findIndex(
                                sideNavLinks,
                                (link) => props.location.pathname.includes(link.to)
                            )
                        }
                        links={sideNavLinks}
                    />
                </LeftColumn>
                <RightColumn className={styles.bindersContainer} explicitRightColumnStyles={true}>
                    {props.children}
                </RightColumn>
            </TwoColumnScaffold>
        </Fragment>
    );
}